import React from 'react';
import LayoutTestPage from './ui/dev/LayoutTestPage';

// 이 파일은 git에 커밋되지 않는 로컬 라우트 정의용 파일입니다.
// 필요한 테스트 페이지나 라우트가 있다면 이곳에 등록하세요.
// 이 파일이 없으면 빌드시 DevRoutes.stub.tsx가 사용됩니다. (vite.config.ts 참조)

const DevRoutes: { path: string; element: React.ReactNode }[] = [
  { path: '/dev-layout-test', element: <LayoutTestPage /> },
];

export default DevRoutes;
